<template>
  <LayoutAuthPrimary>
    <div :style="style.container">
      <CardSecondary :style="style.card">
        <div :style="style.header">
          <HeaderLargePrimary>
            Reset password
          </HeaderLargePrimary>
          <TextWarningPrimary
            v-if="errorMessage.message"
            :style="style.error"
          >
            {{ errorMessage.message }}
          </TextWarningPrimary>
        </div>
        <template v-if="isRequesting">
          <BeatLoaderPrimary>
            <template v-slot:footer>
              Processing password reset.
            </template>
          </BeatLoaderPrimary>
        </template>
        <template v-else-if="requestDone">
          <div>
            <TextRegular>
              Password is successfully updated.
            </TextRegular>
            <TextRegular :isInline="true">
              Back to
            </TextRegular><!-- Avoid auto-added whitespace
         --><LinkPrimary :to="{ name: 'login' }"><!--
           -->Log in<!--
         --></LinkPrimary><!--
         --><TextRegular :isInline="true"><!--
           -->.<!--
         --></TextRegular>
          </div>
        </template>
        <template v-else>
          <FormPasswordResetPrimary :form.sync="form" />
        </template>
        <ButtonWidePrimary
          :disabled="disablePasswordReset"
          @click="resetPassword"
        >
          Reset and log in
        </ButtonWidePrimary>
      </CardSecondary>
    </div>
  </LayoutAuthPrimary>
</template>

<script>
  import ApiPasswordReset from '@js/api/password-reset'
  import BeatLoaderPrimary from '@modules/v2/loader/beat-loader-primary'
  import ButtonWidePrimary from '@modules/v2/button/button-wide-primary'
  import CardSecondary from '@modules/v2/card/card-secondary'
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import HttpStatus from 'http-status-codes'
  import FormPasswordResetPrimary from '@modules/v2/form/form-password-reset-primary'
  import LayoutAuthPrimary from '@modules/v2/layout/layout-auth-primary'
  import LinkPrimary from '@modules/v2/link/link-primary'
  import TextRegular from '@modules/v2/text/text-regular'
  import TextWarningPrimary from '@modules/v2/text/text-warning-primary'
  import { FormPasswordReset } from '@js/forms/password-reset'
  import { Layout } from '@js/styles'
  import { TimerMessage } from '@js/interface-utils'

  export default {
    name: 'PasswordResetView',
    components: {
      BeatLoaderPrimary,
      ButtonWidePrimary,
      CardSecondary,
      FormPasswordResetPrimary,
      HeaderLargePrimary,
      LayoutAuthPrimary,
      LinkPrimary,
      TextRegular,
      TextWarningPrimary,
    },
    props: {
      state: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        errorMessage: new TimerMessage(),
        form: new FormPasswordReset(),
        isRequesting: false,
        requestDone: false,
        style: {
          card: {
            alignItems: 'center',
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            height: 'fit-content',
            justifyContent: 'space-between',
            maxHeight: '360px',
            maxWidth: '400px',
            padding: `${Layout.space.xl} ${Layout.space.lg}`,
            width: '90%',
          },
          container: {
            alignItems: 'center',
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'center',
            padding: `${Layout.space.lg} 0`,
            width: '100%',
          },
          error: {
            display: 'flex',
            justifyContent: 'center',
            position: 'absolute',
            top: Layout.space.lg,
            width: '100%',
          },
          header: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            width: '100%',
          },
        },
      };
    },
    created: function () {
      if (!this.state.passwordResetCode) {
        this.$router.push({ name: 'password-reset' });
      }
      this.form.data.email = this.state.email;
      this.form.data.passwordResetCode = this.state.passwordResetCode;
    },
    computed: {
      disablePasswordReset: function () {
        return this.form.errors.length > 0 || this.isRequesting;
      },
    },
    methods: {
      resetPassword: async function () {
        try {
          this.isRequesting = await true;
          const payload = this.form.getPostPayload();
          const api = await new ApiPasswordReset();
          const res = await api.post(payload);
          if (!res.data.success) {
            throw {
              response: {
                status: HttpStatus.GONE,
                data: {
                  messages: [res.data.message],
                },
              },
            };
          }
          await this.$store.commit(
            'notification/setMessage',
            'Successfully updated password.',
          );
          await this.$router.push({ name: 'login' });
        } catch (error) {
          console.error(error);
          this.form.data.password = '';
          if (error?.response?.status === HttpStatus.GONE) {
            this.errorMessage.set(error?.response?.data?.messages[0]);
          } else {
            this.$store.commit(
              'notification/setWarning',
              'Failed to update password.',
            );
          }
        } finally {
          this.isRequesting = false;
        }
      },
    },
  };
</script>
